import {useCallback, useRef} from 'react';
import {Func} from '../../shared-common/types/Func';
import {isNil} from 'lodash-es';

export const useBusyTimer = (idleMilliseconds: number, label: string = 'Duration'): {
  onBusy: Func
} => {
  const startTimeRef = useRef<number>(null);
  const timeoutHandle = useRef<number>(null);

  const onIdle = useCallback(
    () => {
      if (isNil(startTimeRef.current)) {
        return;
      }

      const now = performance.now();
      const durationMilliseconds = now - startTimeRef.current - idleMilliseconds;
      const durationSeconds = durationMilliseconds / 1000;

      // tslint:disable-next-line:no-console
      console.debug(
        `${label}: `
        + `${durationMilliseconds.toLocaleString(undefined, {maximumFractionDigits: 0, useGrouping: false})} ms `
        + `(${durationSeconds.toLocaleString(undefined, {maximumFractionDigits: 2})} sec)`
      );
      startTimeRef.current = null;
    },
    [label]
  );

  const onBusy = useCallback(
    () => {
      if (isNil(startTimeRef.current)) {
        startTimeRef.current = performance.now();
      }

      if (!isNil(timeoutHandle.current)) {
        window.clearTimeout(timeoutHandle.current);
      }
      timeoutHandle.current = window.setTimeout(onIdle, idleMilliseconds);
    },
    [onIdle]
  );

  return {
    onBusy: onBusy
  };
};
